import styled from "styled-components";

export const Wrapper = styled.div`
    width: 100%;
    display: flex;
    height: 130px;
    justify-content: flex-start;
    align-items: flex-end;
    margin-top: 60px;
    margin-bottom: 60px;
    gap: 30px;
    @media (max-width: 992px) {
        gap: 10px;
    }
    @media (max-width: 768px) {
        flex-wrap: wrap;
        height: auto;
        gap: 10px;
    }
`;

export const Box = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    width: 178px;
    height: 160px;
    border-radius: 5px;
    text-align: center;
    padding: 4px;
    padding-top: 16px;
    padding-bottom: 16px;
    //figma drop shadow  x:0 y:4 blur:4 spread:0 color:rgba(0,0,0,0.25)
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);

    border: ${$props => ($props.isActive ? "1px solid #91d5ff" : "none")};
    background-color: ${$props => ($props.isActive ? "#e6f7ff" : "none")};

    b {
        line-height: 1.2;
    }
    img {
        width: 100%;
        max-height: 50px;
    }
    .credit-top-info {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        .credit-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            font-size: 24px;
            flex: 2;
        }
    }

    .payment-button-container {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        text-decoration: underline;
        margin-right: 10px;
        cursor: pointer;
    }

    .contract-container {
        display: flex;
        align-items: center;
        width: 100%;
        gap: 15px;
        img {
            flex: 1;
        }
        .contract-detail {
            flex: 2;
            .contract-info {
                display: flex;
                flex-direction: column;
            }
        }
    }
    .all-contracts {
        display: flex;
        width: 100%;
        justify-content: flex-end;
        align-items: center;
        .anticon {
            margin-left: 2px;
        }
        .ant-btn {
            border: none;
            color: #9e9e9e;
        }
    }

    cursor: ${$props => ($props.onClick ? "pointer" : "default")};

    &:hover {
        background-color: ${$props => ($props.onClick ? "#f7f7f7" : "none")};
    }
`;

export const InfoRow = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    margin-left: 5px;
    img {
        max-width: 17px;
    }
    div {
        margin-left: 3px;
        font-size: 10px;
        font-weight: 600;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
    }
`;

export const InfoSeparator = styled.div`
    width: 100%;
    height: 1px;
    background-color: #d9d9d9;
    margin: 5px 0;
`;
